(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentsEdit',
	};

	var CONTACT_PHOTO_MIN_BYTES = 1;
	var CONTACT_PHOTO_MAX_BYTES = 4 * 1024 * 1024;
	var CONTACT_PHOTO_MIN_WIDTH  = 936;
	var CONTACT_PHOTO_MIN_HEIGHT = 936;
	var CONTACT_PHOTO_MIN_DPI    = 72;
	var CONTACT_PHOTO_EXTENSIONS = ['jpg', 'jpeg', 'png'];
	var skipContactPhotoCaptureValidation = false;

	var MAX_SPECIALTIES = 15;
	var MAX_FEATURED    = 3;

	/**
	 * Maps the field-name suffix to category slug and display label.
	 * The slug must match the category_name stored in agent_advisor_specialties.
	 */
	var CATEGORY_MAP = {
		destination_specialties: {
			slug : 'destination',
			label: 'Destination',
		},
		trip_type_specialties: {
			slug : 'trip_type',
			label: 'Trip Type',
		},
		brand_specialties: {
			slug : 'brand',
			label: 'Brand',
		},
		interest_style_specialties: {
			slug : 'interest_style',
			label: 'Interest/Style',
		},
	};

	function getContactPhotoFileInput()
	{
		return $('.contact-photo-file-input').find('input[data-form-component-image]');
	}

	function getFileExtension(fileName)
	{
		var parts = fileName.split('.');

		if (parts.length < 2) {
			return '';
		}

		return parts.pop().toLowerCase();
	}

	function isValidContactPhotoFile(file)
	{
		var extension;
		var message = '';

		if (!file) {
			return {
				valid  : false,
				message: 'Please select a photo to upload.',
			};
		}

		extension = getFileExtension(file.name);

		if (CONTACT_PHOTO_EXTENSIONS.indexOf(extension) === -1) {
			message = 'Photo must be a JPG or PNG file.';
		} else if (file.size < CONTACT_PHOTO_MIN_BYTES) {
			message = 'Photo file cannot be empty.';
		} else if (file.size > CONTACT_PHOTO_MAX_BYTES) {
			message = 'Photo must be no larger than 4 MB.';
		}

		if (message) {
			return {
				valid  : false,
				message: message,
			};
		}

		return {
			valid  : true,
			message: '',
		};
	}

	function showContactPhotoError(message)
	{
		Adzuki.StatusMessage('Error', message);
	}

	function assignFileToInput($fileInput, file)
	{
		var dataTransfer;

		if (typeof DataTransfer === 'undefined') {
			showContactPhotoError('Your browser does not support drag and drop uploads. Please use browse to select a photo.');
			return false;
		}

		dataTransfer = new DataTransfer();
		dataTransfer.items.add(file);
		$fileInput[0].files = dataTransfer.files;

		return true;
	}

	function readUint32BE(buffer, offset)
	{
		return ((buffer[offset] << 24) | (buffer[offset + 1] << 16) | (buffer[offset + 2] << 8) | buffer[offset + 3]) >>> 0;
	}

	function getJpegDpiFromBuffer(buffer)
	{
		var i = 2;
		var length = buffer.length;
		var marker;
		var segmentLength;
		var units;
		var xDensity;

		while (i + 4 < length) {
			if (buffer[i] !== 0xFF) {
				i++;
				continue;
			}

			marker = buffer[i + 1];

			if (marker === 0xD9) {
				break;
			}

			segmentLength = (buffer[i + 2] << 8) + buffer[i + 3];

			if (marker === 0xE0 && i + 18 < length) {
				if (
					buffer[i + 4] === 0x4A
					&& buffer[i + 5] === 0x46
					&& buffer[i + 6] === 0x49
					&& buffer[i + 7] === 0x46
				) {
					units = buffer[i + 11];
					xDensity = (buffer[i + 12] << 8) + buffer[i + 13];

					if (units === 1 && xDensity > 0) {
						return xDensity;
					}

					if (units === 2 && xDensity > 0) {
						return Math.round(xDensity * 2.54);
					}
				}
			}

			i += 2 + segmentLength;
		}

		return null;
	}

	function getPngDpiFromBuffer(buffer)
	{
		var offset = 8;
		var length;
		var chunkType;
		var xPpm;
		var unit;

		if (buffer.length < 24) {
			return null;
		}

		while (offset + 12 <= buffer.length) {
			length = readUint32BE(buffer, offset);
			chunkType = String.fromCharCode(
				buffer[offset + 4],
				buffer[offset + 5],
				buffer[offset + 6],
				buffer[offset + 7]
			);

			if (chunkType === 'pHYs' && offset + 17 <= buffer.length) {
				xPpm = readUint32BE(buffer, offset + 8);
				unit = buffer[offset + 16];

				if (unit === 1 && xPpm > 0) {
					return Math.round(xPpm * 0.0254);
				}

				return null;
			}

			offset += 12 + length;
		}

		return null;
	}

	function getImageDpiFromFile(file)
	{
		return new Promise(function readImageDpi(resolve) {
			var reader = new FileReader();
			var extension = getFileExtension(file.name);

			reader.onload = function onLoad(event) {
				var buffer = new Uint8Array(event.target.result);
				var dpi = null;

				if (extension === 'jpg' || extension === 'jpeg') {
					dpi = getJpegDpiFromBuffer(buffer);
				} else if (extension === 'png') {
					dpi = getPngDpiFromBuffer(buffer);
				}

				resolve(dpi);
			};

			reader.onerror = function onError() {
				resolve(null);
			};

			reader.readAsArrayBuffer(file);
		});
	}

	function validateContactPhotoRequirements(file)
	{
		return new Promise(function validatePhoto(resolve) {
			var basicValidation = isValidContactPhotoFile(file);
			var objectUrl;
			var img;

			if (!basicValidation.valid) {
				resolve(basicValidation);
				return;
			}

			objectUrl = URL.createObjectURL(file);
			img = new Image();

			img.onload = function onImageLoad() {
				var width = img.naturalWidth;
				var height = img.naturalHeight;

				URL.revokeObjectURL(objectUrl);

				if (width < CONTACT_PHOTO_MIN_WIDTH || height < CONTACT_PHOTO_MIN_HEIGHT) {
					resolve({
						valid  : false,
						message: 'Photo must be at least ' + CONTACT_PHOTO_MIN_WIDTH + ' x ' + CONTACT_PHOTO_MIN_HEIGHT + ' pixels.',
					});
					return;
				}

				getImageDpiFromFile(file).then(function checkDpi(dpi) {
					if (dpi !== null && dpi < CONTACT_PHOTO_MIN_DPI) {
						resolve({
							valid  : false,
							message: 'Photo must have a resolution of at least ' + CONTACT_PHOTO_MIN_DPI + ' dpi.',
						});
						return;
					}

					resolve({
						valid  : true,
						message: '',
					});
				});
			};

			img.onerror = function onImageError() {
				URL.revokeObjectURL(objectUrl);
				resolve({
					valid  : false,
					message: 'Photo must be a valid JPG or PNG file.',
				});
			};

			img.src = objectUrl;
		});
	}

	function triggerContactPhotoCropper($fileInput, file)
	{
		if (!assignFileToInput($fileInput, file)) {
			return;
		}

		skipContactPhotoCaptureValidation = true;
		$fileInput.trigger('change');
	}

	function processContactPhotoFile($fileInput, file)
	{
		validateContactPhotoRequirements(file).then(function onValidated(validation) {
			if (!validation.valid) {
				$fileInput.val('');
				showContactPhotoError(validation.message);
				return;
			}

			triggerContactPhotoCropper($fileInput, file);
		});
	}

	function syncPreviewAltText()
	{
		var altText = $('#contact-photo-alt-text').val();

		$('.contact-photo-preview').attr('alt', altText);
	}

	function updateContactPhotoPreview(imageData)
	{
		var $preview = $('.contact-photo-preview');
		var $previewGroup = $('.contact-photo-preview-group');
		var $altTextGroup;
		var $formGroup;
		var $labelCol;
		var $previewCol;
		var $container;

		if (!imageData) {
			return;
		}

		if (!$preview.length) {
			$altTextGroup = $('#contact-photo-alt-text').closest('.form-group');
			$formGroup = $('<div class="form-group contact-photo-preview-group"></div>');
			$labelCol = $('<label class="col-sm-3 control-label">Current Photo</label>');
			$previewCol = $('<div class="col-sm-9"></div>');
			$container = $('<div class="text-center width-auto image-container"></div>');
			$preview = $('<img>', {
				class: 'contact-photo-preview',
				alt  : $('#contact-photo-alt-text').val() || '',
			});

			$container.append($preview);
			$previewCol.append($container);
			$formGroup.append($labelCol).append($previewCol);

			if ($altTextGroup.length) {
				$altTextGroup.before($formGroup);
			} else {
				$('.contact-photo-dropzone').closest('.form-group').after($formGroup);
			}

			$previewGroup = $formGroup;
		}

		$preview.attr('src', imageData);
		$previewGroup.removeClass('hidden');
		syncPreviewAltText();
	}

	function fetchContactPhotoPreview(mediaId, section)
	{
		var url = Adzuki.base_uri + '/Media/getAssetData';
		var requestData = new FormData();

		requestData.append('media_id', mediaId);
		requestData.append('section', section);

		fetch(url, {
			method: 'POST',
			body  : requestData,
		})
			.then(function parseResponse(response) {
				if (!response.ok) {
					throw new Error('Error fetching asset data');
				}

				return response.json();
			})
			.then(function updatePreview(data) {
				var files = data.files;
				var file;
				var previewUrl;

				if (!files) {
					return;
				}

				file = Array.isArray(files) ? files[0] : files;

				if (!file) {
					return;
				}

				previewUrl = file.remote_url || file.path;

				if (previewUrl) {
					updateContactPhotoPreview(previewUrl + '?rand=' + Date.now());
				}
			})
			.catch(function onError(error) {
				console.error('Error fetching contact photo preview:', error);
			});
	}

	function initContactPhotoMediaHub()
	{
		var $mediaHub = $('#erez-mediahub');
		var $mediaIdInput = $('input[id*="media_id"]');
		var section;

		if (!$mediaHub.length || !$mediaIdInput.length) {
			return;
		}

		section = $mediaHub.data('section') || 'agent';

		$mediaIdInput.on('change', function onMediaIdChange() {
			var mediaIdValue = $(this).val();
			var mediaIds;

			if (!mediaIdValue) {
				return;
			}

			mediaIds = mediaIdValue.split(',').map(function trimId(id) {
				return id.trim();
			}).filter(Boolean);

			if (!mediaIds.length) {
				return;
			}

			fetchContactPhotoPreview(mediaIds[mediaIds.length - 1], section);
		});
	}

/*	function persistAltText()
	{
		try {
			sessionStorage.setItem(ALT_TEXT_STORAGE_KEY, $('#contact-photo-alt-text').val());
		} catch (err) {
			// sessionStorage may be unavailable
		}
	}

	function restoreAltText()
	{
		var storedAltText = '';

		try {
			storedAltText = sessionStorage.getItem(ALT_TEXT_STORAGE_KEY);
		} catch (err) {
			storedAltText = '';
		}

		if (storedAltText !== null && storedAltText !== '') {
			$('#contact-photo-alt-text').val(storedAltText);
		}

		syncPreviewAltText();
	}*/

	function initContactPhotoDropzone()
	{
		var $fileInput = getContactPhotoFileInput();
		var $dropzone = $('.contact-photo-dropzone');
		var $dragArea = $dropzone.find('.contact-photo-draganddrop');

		if (!$fileInput.length || !$dropzone.length) {
			return;
		}

		$fileInput.on('adzuki.cropped', function onContactPhotoCropped(event, cropData) {
			if (cropData && cropData.image_data) {
				updateContactPhotoPreview(cropData.image_data);
			}
		});

		$fileInput.each(function bindContactPhotoValidation() {
			this.addEventListener('change', function contactPhotoChange(event) {
				var file = this.files[0];
				var $input = $(this);

				if (!file) {
					return;
				}

				if (skipContactPhotoCaptureValidation) {
					skipContactPhotoCaptureValidation = false;
					return;
				}

				event.stopImmediatePropagation();
				event.preventDefault();

				validateContactPhotoRequirements(file).then(function onValidated(validation) {
					if (!validation.valid) {
						$input.val('');
						showContactPhotoError(validation.message);
						return;
					}

					triggerContactPhotoCropper($input, file);
				});
			}, true);
		});

		$dropzone.on('click', '.contact-photo-browse', function browseContactPhoto(event) {
			event.preventDefault();
			$fileInput.trigger('click');
		});

		$dragArea.on('dragenter dragover', function dragOver(event) {
			event.preventDefault();
			event.stopPropagation();
			$(this).addClass('attachment-drag-enter');
		});

		$dragArea.on('dragleave drop', function dragLeave(event) {
			event.preventDefault();
			event.stopPropagation();
			$(this).removeClass('attachment-drag-enter');
		});

		$dragArea.on('drop', function dropContactPhoto(event) {
			var files = event.originalEvent.dataTransfer.files;

			if (!files || !files.length) {
				return;
			}

			processContactPhotoFile($fileInput, files[0]);
		});
	}

	function initContactPhotoAltText()
	{
		var altTextMaxLength = 150;
		var $altText = $('#contact-photo-alt-text');
		var $altTextCount = $('#contact-photo-alt-text-count');

		function updateAltTextRemaining()
		{
			var remaining = altTextMaxLength - $altText.val().length;

			$altTextCount.html(remaining + ' characters remaining');
			$altTextCount.css('color', (remaining <= 10 ? 'red' : ''));
		}

		if (!$altText.length || !$altTextCount.length) {
			return;
		}

		$altText.attr('maxlength', altTextMaxLength);

		updateAltTextRemaining();

		if (typeof Adzuki.CharacterCount === 'function') {
			Adzuki.CharacterCount($altText, {
				max  : altTextMaxLength,
				label: $altTextCount,
			});
		}

		$altText.on('input', function updateAltText() {
			var value = $altText.val();

			if (value.length > altTextMaxLength) {
				value = value.substring(0, altTextMaxLength);
				$altText.val(value);
			}

			updateAltTextRemaining();
			syncPreviewAltText();
		});
	}
	/**
	 * Return the category key (e.g. "destination_specialties") from a
	 * select element's full name attribute.
	 */
	function getCategoryKey($select)
	{
		var name = $select.attr('name') || '';
		var match = null;

		$.each(CATEGORY_MAP, function __findKey(key) {
			if (name.indexOf('[' + key + ']') !== -1) {
				match = key;
				return false;
			}
		});

		return match;
	}

	/**
	 * Collect every selected option across all four dropdowns,
	 * preserving saved priority/featured from the DB when available.
	 *
	 * Returns an ordered array of item objects.
	 */
	function collectAllSelections()
	{
		var items   = [];
		var saved   = window.SAVED_ADVISOR_SPECIALTIES || [];
		var savedMap = {};

		$.each(saved, function __buildSavedMap(i, row) {
			savedMap[row.category_name + '|' + row.option_name] = row;
		});

		$('select.advisor-specialty-select').each(function __perSelect() {
			var $select = $(this);
			var catKey  = getCategoryKey($select);
			var info;

			if (!catKey) {
				return;
			}

			info = CATEGORY_MAP[catKey];

			$select.find('option:selected').each(function __perOption() {
				var $opt       = $(this);
				var optionName = $opt.val();
				var optionText = $opt.text();
				var lookupKey  = info.slug + '|' + optionName;
				var savedRow   = savedMap[lookupKey];

				items.push({
					categorySlug : info.slug,
					categoryLabel: info.label,
					optionName   : optionName,
					optionText   : optionText,
					displayName  : info.label + ' \u2013 ' + optionText,
					priority     : savedRow ? parseInt(savedRow.priority, 10) : 0,
					featured     : savedRow ? parseInt(savedRow.featured, 10) : 0,
				});
			});
		});

		// Sort: items with a saved priority first (ascending), then new items
		items.sort(function __sortByPriority(a, b) {
			var pa = a.priority || 9999;
			var pb = b.priority || 9999;
			return pa - pb;
		});

		// Reassign sequential priority 1..N
		$.each(items, function __resequence(i) {
			items[i].priority = i + 1;
		});

		return items;
	}

	/**
	 * Render the specialty table, counters, badges, and hidden fields.
	 */
	function renderSpecialtyTable()
	{
		var items       = collectAllSelections();
		var $tbody      = $('#specialty-table-body');
		var $hidden     = $('#specialty-hidden-fields');
		var $countBadge = $('#specialty-count-number').closest('.label');
		var $featBadge  = $('#featured-count-number').closest('.label');
		var featuredCt  = 0;
		var html        = '';
		var hiddenHtml  = '';

		// Count featured
		$.each(items, function __countFeatured(i, item) {
			if (item.featured) {
				featuredCt++;
			}
		});

		// Update counters
		$('#specialty-count-number').text(items.length);
		$('#featured-count-number').text(featuredCt);

		// Badge colours
		if (items.length > MAX_SPECIALTIES) {
			$countBadge.removeClass('label-info label-success').addClass('label-danger');
		} else if (items.length === MAX_SPECIALTIES) {
			$countBadge.removeClass('label-info label-danger').addClass('label-success');
		} else {
			$countBadge.removeClass('label-danger label-success').addClass('label-info');
		}

		if (featuredCt >= MAX_FEATURED) {
			$featBadge.removeClass('label-default').addClass('label-success');
		} else {
			$featBadge.removeClass('label-success').addClass('label-default');
		}

		if (items.length === 0) {
			html = '<tr id="no-specialties-row"><td colspan="3" class="text-center text-muted"><em>No specialties selected.</em></td></tr>';
		} else {
			$.each(items, function __buildRow(i, item) {
				var checkedAttr  = item.featured ? ' checked' : '';
				var disabledAttr = (!item.featured && featuredCt >= MAX_FEATURED) ? ' disabled' : '';
				var priorityOpts = '';
				var prefix       = 'form_component_data[AgentsEdit]';
				var p;
				var selAttr;
				var featuredCell = '';


				for (p = 1; p <= items.length; p++) {
					selAttr = (p === item.priority) ? ' selected' : '';
					priorityOpts += '<option value="' + p + '"' + selAttr + '>' + p + '</option>';
				}

				if (disabledAttr) {
					featuredCell = '<td class="text-center">'
						+ '<span data-toggle="tooltip" title="Only up to three specialties can be featured">'
						+ '<input type="checkbox" class="specialty-featured-check" data-idx="' + i + '"' + disabledAttr + ' />'
						+ '</span></td>';
				} else {
					featuredCell = '<td class="text-center">'
						+ '<input type="checkbox" class="specialty-featured-check" data-idx="' + i + '"' + checkedAttr + ' />'
						+ '</td>';
				}

				html += '<tr data-category="' + item.categorySlug + '" data-option="' + $('<div/>').text(item.optionName).html() + '">'
					+ '<td>' + $('<div/>').text(item.displayName).html() + '</td>'
					+ '<td><select class="form-control input-sm specialty-priority-select" data-idx="' + i + '">' + priorityOpts + '</select></td>'
					+ featuredCell
					+ '</tr>';

				hiddenHtml += '<input type="hidden" name="' + prefix + '[specialty_items][]" value="' + item.categorySlug + '|' + $('<div/>').text(item.optionName).html() + '" />';
				hiddenHtml += '<input type="hidden" name="' + prefix + '[specialty_priority][]" value="' + item.priority + '" />';
				hiddenHtml += '<input type="hidden" name="' + prefix + '[specialty_featured][]" value="' + (item.featured ? '1' : '0') + '" />';
			});
		}

		$tbody.html(html);
		$hidden.html(hiddenHtml);

		// Debug: log the hidden fields being created
		console.log('=== Advisor Specialties DEBUG ===');
		console.log('Number of items:', items.length);
		console.log('Hidden fields container:', $hidden.length ? 'found' : 'NOT FOUND');
		console.log('Hidden fields HTML length:', hiddenHtml.length);
		console.log('Hidden inputs created:', $hidden.find('input[type="hidden"]').length);
		console.log('Hidden fields HTML:', hiddenHtml);

		// Initialise tooltips on the priority header icon
		$('[data-toggle="tooltip"]').tooltip();
	}

	/**
	 * Handle a priority dropdown change: swap priorities to prevent gaps.
	 */
	function onPriorityChange()
	{
		var $sel   = $(this);
		var newPri = parseInt($sel.val(), 10);
		var idx    = parseInt($sel.data('idx'), 10);
		var items  = collectAllSelections();
		var oldPri;

		if (idx < 0 || idx >= items.length) {
			return;
		}

		oldPri = items[idx].priority;

		if (newPri === oldPri) {
			return;
		}

		// Perform a swap/shift so there are no gaps
		$.each(items, function __shift(i) {
			if (i === idx) {
				return;
			}
			if (oldPri < newPri && items[i].priority > oldPri && items[i].priority <= newPri) {
				items[i].priority--;
			} else if (oldPri > newPri && items[i].priority >= newPri && items[i].priority < oldPri) {
				items[i].priority++;
			}
		});

		items[idx].priority = newPri;

		// Persist updated priority/featured back to SAVED so next render keeps them
		updateSavedState(items);
		renderSpecialtyTable();
	}

	/**
	 * Handle featured checkbox toggle.
	 */
	function onFeaturedToggle()
	{
		var $cb        = $(this);
		var idx        = parseInt($cb.data('idx'), 10);
		var items      = collectAllSelections();
		var featuredCt = 0;

		$.each(items, function __count(i, item) {
			if (item.featured) {
				featuredCt++;
			}
		});

		if ($cb.is(':checked') && featuredCt >= MAX_FEATURED) {
			$cb.prop('checked', false);
			return;
		}

		if (idx >= 0 && idx < items.length) {
			items[idx].featured = $cb.is(':checked') ? 1 : 0;
		}

		updateSavedState(items);
		renderSpecialtyTable();
	}

	/**
	 * Write the current items list back into SAVED_ADVISOR_SPECIALTIES
	 * so that subsequent collectAllSelections() preserves the state.
	 */
	function updateSavedState(items)
	{
		var newSaved = [];

		$.each(items, function __toSaved(i, item) {
			newSaved.push({
				category_name: item.categorySlug,
				option_name  : item.optionName,
				priority     : item.priority,
				featured     : item.featured,
				display_name : item.displayName,
			});
		});

		window.SAVED_ADVISOR_SPECIALTIES = newSaved;
	}

	/**
	 * Enforce the 15-specialty cap by disabling unselected options
	 * when the limit is reached.
	 */
	function enforceSpecialtyLimit()
	{
		var total = 0;

		$('select.advisor-specialty-select').each(function __countAll() {
			var val = $(this).val();
			if (val && val.length) {
				total += val.length;
			}
		});

		$('select.advisor-specialty-select').each(function __toggleDisabled() {
			var $select = $(this);

			$select.find('option').each(function __perOpt() {
				var $opt = $(this);
				if (total >= MAX_SPECIALTIES && !$opt.is(':selected')) {
					$opt.prop('disabled', true);
				} else {
					$opt.prop('disabled', false);
				}
			});

			$select.selectpicker('refresh');
		});
	}

	/**
	 * SET-16: EVERYTHING THIS FILE WIRES MOVED HERE FROM document.ready.
	 *
	 * It all ran at ready and nowhere else, so none of it reached a form rendered by AJAX -
	 * which is every panel of the My Settings modal. The contact photo picker, its alt-text
	 * counter and the specialty table were all inert there.
	 *
	 * ONE CODE PATH, NOT TWO. Adzuki.Form.registerForm() calls load() at ready when the form is
	 * on the page, and initAjaxForm() calls it again after each panel render - so the legacy
	 * /Agents/edit screen and the modal wire up through the same function. Duplicating these
	 * calls in a panel-specific file was the alternative, and these are private to this IIFE.
	 *
	 * SAFE TO RE-RUN: every handler below binds to an element inside the form, and the form is
	 * replaced wholesale on each render, so the old bindings go with the old DOM. Nothing here
	 * delegates from document or body - which is what made AgentsSettingsForm.js stack up one
	 * handler per render until SET-55 namespaced it.
	 */
	form.load = function load()
	{
		// Contact photo handling
		initContactPhotoDropzone();
		initContactPhotoMediaHub();
		initContactPhotoAltText();

		// THE PICKER IS A VUE APP, and mediahub_component.js mounts it at document ready over
		// .mh-btn-container - which an injected panel misses. init() takes one element and
		// guards itself with a vue-initialized data flag, so calling it per render is safe and
		// a second call on the same element is a no-op.
		if (Adzuki.MediaHubComponent && typeof Adzuki.MediaHubComponent.init === 'function') {
			$('.mh-btn-container').each(function mountMediaHubPicker() {
				Adzuki.MediaHubComponent.init(this);
			});
		}

		// Advisor specialties (only if the form contains the specialty selects). SET-18 owns that
		// panel; the wiring moved with the rest so it works when that tab is built.
		if ($('select.advisor-specialty-select').length === 0) {
			return;
		}

		$('select.advisor-specialty-select').on('changed.bs.select', function __onSpecialtyChange() {
			enforceSpecialtyLimit();
			renderSpecialtyTable();
		});

		$('#specialty-table-body').on('change', '.specialty-priority-select', onPriorityChange);
		$('#specialty-table-body').on('change', '.specialty-featured-check', onFeaturedToggle);

		enforceSpecialtyLimit();
		renderSpecialtyTable();
	};

	$(document).ready(function documentReady()
	{
		// registerForm() runs load() itself when this form is already on the page
		Adzuki.Form.registerForm(form);
	});
}(jQuery, window.Adzuki || {}));
